const SELECTORS = {
    minicartCounter: '.js-bag-counter',
    wishlistCounter: '.js-wishlist-count',
    minicartWrapper: '.header-actions-item--cart',
    minicartButton: '.minicart-button',
    accountIconFill: 'js-account-filled',
    accountIconEmpty: 'js-account-empty'
};
export default class LoadCustomerStatus {
    init() {
        // This fetch will load customer status such as cart and wishlist counter and GTM personal data event asynchronously to allow akamai home page cache
        if (window.isCurrentActionAkamaiCache) {
            const url = window.getCustomerStatusUrl;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(res => {
                if (res) {
                    if (res.wishlistQuantity && res.wishlistQuantity > 0) {
                        // UPDATE WISHLIST QUANTITY
                        const wishlistCounter = document.querySelector(SELECTORS.wishlistCounter);
                        wishlistCounter.innerHTML = res.wishlistQuantity.toFixed();
                        wishlistCounter.style.display = 'flex';
                        wishlistCounter.dataset.wishlistcounter = res.wishlistQuantity.toFixed();
                    }
                    if (res.cartQuantity && res.cartQuantity > 0) {
                        // UPDATE MINI CART QUANTITY
                        const minicartCounter = document.querySelector(SELECTORS.minicartCounter);
                        const minicartWrapper = document.querySelector(SELECTORS.minicartWrapper);
                        const minicartTotalItems = minicartWrapper.querySelector('[data-totalitems]');
                        const minicartButton = document.querySelector(SELECTORS.minicartButton);
                        minicartButton.setAttribute('aria-label', res.cartMessage);
                        minicartTotalItems.dataset.totalitems = res.cartQuantity.toFixed();
                        minicartCounter.innerHTML = res.cartQuantity.toFixed();
                        minicartCounter.classList.remove('d-none');
                    }
                    if (res.loginStatus === 'logged') {
                        document.querySelector(`.${SELECTORS.accountIconFill}`).classList.remove('d-none');
                        document.querySelector(`.${SELECTORS.accountIconEmpty}`).classList.add('d-none');
                    }
                    // UPDATE GTM HASHED EMAIL AND IS LOGGED ON DATALAYER EVENT AND PUSH IT
                    window.dataLayer[0].login = res.personalData.login;
                    window.dataLayer[0].userId = res.personalData.userId;
                    window.dataLayer[0].userIdSFCC = res.personalData.userIdSFCC;
                    if (res.personalData.sha256email) {
                        window.dataLayer[0].sha256email = res.personalData.sha256email;
                    }
                }
            })
                .catch(error => console.error('Error fetching customer status:', error));
        }
    }
}
